const USER_FIRST_NAME = "USER_FIRST_NAME";
const USER_LAST_NAME = "USER_LAST_NAME";
const USER_EMAIL = "USER_EMAIL";
const USER_PASSWORD = "USER_PASSWORD";
const USER_CONFIRM_PASSWORD = "USER_CONFIRM_PASSWORD";
const IS_USER_LOGGED_IN = "IS_USER_LOGGED_IN";
const AUTH_TOKEN = "AUTH_TOKEN";

export {
  USER_FIRST_NAME,
  USER_LAST_NAME,
  USER_EMAIL,
  USER_PASSWORD,
  USER_CONFIRM_PASSWORD,
  IS_USER_LOGGED_IN,

  AUTH_TOKEN
};
